import React, { Component } from 'react';
import { Col } from 'react-bootstrap';

import { SummaryItem } from './SummaryItem';

export class SummaryPanel extends Component {

    constructor(props) {
      super(props);
      this.state = {
        drive: 0
      }
    }

    getSummaryData = () => {

      let summary = {
        drive: 0,
        duty: 0,
        off: 0,
        berth: 0,
        revenue: 0,
        time: 0,
        distance: 0,
        fuel: 0,
        tolls: 0
      };

      this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route) => {
          summary.drive += route.drive;
          summary.duty += route.duty;
          summary.off += route.off;
          summary.berth += route.berth;
          summary.revenue += route.revenue;
          summary.time += route.time;
          summary.distance += route.distance;
          summary.fuel += route.fuel;
          summary.tolls += route.tolls;

          return null;
      })


      return summary;
    }

    render() {
        return(
          <div className="summary-container">
            <SummaryItem title="Drive" value={this.getSummaryData().drive + ' hr'} iconClass="fa-truck"></SummaryItem>
            <SummaryItem title="Duty" value={this.getSummaryData().duty + ' hr'} iconClass="fa-hourglass-start"></SummaryItem>
            <SummaryItem title="Off" value={this.getSummaryData().off + ' hr'}  iconClass="fa-moon-o"></SummaryItem>
            <SummaryItem title="Berth" value={this.getSummaryData().berth + ' hr'}  iconClass="fa-bed"></SummaryItem>
            <SummaryItem title="Rev" value={this.getSummaryData().revenue + ' €'}  iconClass="fa-eur"></SummaryItem>
            <SummaryItem title="Time" value={this.getSummaryData().time + ' hr'}  iconClass="fa-clock-o"></SummaryItem>
            <SummaryItem title="Km" value={this.getSummaryData().distance + ' km'}  iconClass="fa-cogs"></SummaryItem>
            <SummaryItem title="Fuel" value={this.getSummaryData().fuel + ' lt'}  iconClass="fa-battery-full"></SummaryItem>
            <SummaryItem title="Tolls" value={this.getSummaryData().tolls + ' €'}  iconClass="fa-ticket"></SummaryItem>
          </div>
        );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/SummaryPanel.js